import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { useIntl } from 'react-intl';

import { getSemanticColor, useBreakpointValue } from '@notino/react-styleguide';
import {
  RoutineByProductIdQuery,
  ProductRoutineAssetEnum,
} from '@notino/shared/definitions/types';

import { RectanglePlaceholder } from '@components/Placeholders';
import { ExpandableText } from '@sharedComponents/ExpandableText';

import { IProductsCount } from './model';
import {
  Header,
  Asset,
  Content,
  Title,
  Description,
} from './styled/RoutineHeader';

export const youtubeIframe = (src: string) => `
  <iframe
    src="${src}"
    frameborder="0"
    allowfullscreen
  ></iframe>`;

export const RoutineHeader: React.FC<
  Omit<
    NonNullable<
      NonNullable<
        RoutineByProductIdQuery['RoutineByProductId']['routines']
      >[number]
    >,
    'products'
  > &
    IProductsCount
> = ({ title, description, asset, productsCount }) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const isDesktop = useBreakpointValue({ md: true });
  const { formatMessage } = useIntl();

  return (
    <Header productsCount={productsCount}>
      {!!asset?.src?.length && isDesktop && (
        <Asset ref={ref} productsCount={productsCount}>
          {asset.type === ProductRoutineAssetEnum.Image ? (
            inView ? (
              <img src={asset.src} alt={asset.alt ?? undefined} />
            ) : (
              <RectanglePlaceholder />
            )
          ) : (
            <div
              dangerouslySetInnerHTML={{ __html: youtubeIframe(asset.src) }}
            />
          )}
        </Asset>
      )}
      <Content productsCount={productsCount} isAsset={!!asset}>
        <Title dangerouslySetInnerHTML={{ __html: title ?? '' }} />
        {description && (
          <ExpandableText
            disabled={description.length < 160}
            useOnlyOn="mobile"
            buttonText={formatMessage({
              id: 'pd.expandableText.showMoreText',
            })}
            height="72px"
            gradientBgColor={getSemanticColor('background.disabled')}
          >
            <Description>{description}</Description>
          </ExpandableText>
        )}
      </Content>
    </Header>
  );
};
